module.exports = __webpack_public_path__ + "static/img/system-2.b7478b39.png";